import * as React from 'react';
import {
    Alert,
    Box,
    Button,
    CircularProgress,
    FormControlLabel,
    Radio,
    RadioGroup,
    Typography,
} from '@mui/material';

import { useSignup } from '../context';
import { errorText } from '../labels';

// Pick account (plan §16): the access details reach several companies; the client picks theirs.

export default function PickAccount() {
    const { api, flow, dispatch, sessionLost } = useSignup();
    const accounts = flow.accounts || [];
    const initial = [flow.account, flow.resume?.account].find((id) => id && accounts.some((a) => a.id === id)) || '';
    const [choice, setChoice] = React.useState<string>(initial);
    const [busy, setBusy] = React.useState(false);
    const [error, setError] = React.useState<string | null>(flow.flash ? flow.flash.message : null);
    const mounted = React.useRef(true);
    React.useEffect(() => () => { mounted.current = false; }, []);

    const onSubmit = async (ev: React.FormEvent) => {
        ev.preventDefault();
        if (!choice || !flow.restech || busy) { return; }
        setBusy(true);
        setError(null);
        try {
            const view = await api.account(flow.restech.code, flow.credentials, choice);
            dispatch({ type: 'account_viewed', restech: flow.restech, credentials: flow.credentials, accounts, account: choice, view });
            return;
        } catch (e) {
            if (sessionLost(e)) { return; }
            if (mounted.current) { setError(errorText(e)); }
        }
        if (mounted.current) { setBusy(false); }
    };

    return (
        <Box component="form" noValidate onSubmit={onSubmit} aria-label="Choose your company">
            <Typography variant="h5" component="h1" gutterBottom>Choose your company</Typography>
            <Typography color="text.secondary" paragraph>
                Your {flow.restech?.display_name || 'booking system'} details give access to several companies. Which one are you
                setting up?
            </Typography>
            <RadioGroup name="account" value={choice} onChange={(e) => setChoice(e.target.value)}>
                {accounts.map((a) => (
                    <FormControlLabel key={a.id} value={a.id} control={<Radio />} label={a.name || a.id} disabled={busy} />
                ))}
            </RadioGroup>
            {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
            <Box sx={{ mt: 3, display: 'flex', gap: 1 }}>
                <Button type="button" onClick={() => dispatch({ type: 'go', step: 'connect' })} disabled={busy}>Back</Button>
                <Button type="submit" variant="contained" disabled={!choice || busy}
                    startIcon={busy ? <CircularProgress size={18} color="inherit" /> : undefined}>
                    Continue
                </Button>
            </Box>
        </Box>
    );
}
